import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/** Parse `currentUser` from disk; never leave a raw string on the subject. */
function readStoredUserJson(): any {
  try {
    const raw = localStorage.getItem('currentUser');
    if (raw == null || raw === '') {
      return {};
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private userDetailsSubject = new BehaviorSubject<any>(readStoredUserJson());
  userDetailsSubject$!: Observable<any>;
  private encClaimIdSubject = new BehaviorSubject<any>('');
  encClaimIdSubject$!: Observable<any>;
  private estimateDetailsSubject: BehaviorSubject<boolean> = new BehaviorSubject<any>({});
  estimateDetailsSubject$!: Observable<any>;
  private paymentDetailSubject: BehaviorSubject<boolean> = new BehaviorSubject<any>({});
  paymentDetailSubject$!: Observable<any>;
  private garageDetailSubject: BehaviorSubject<boolean> = new BehaviorSubject<any>({});
  garageDetailSubject$!: Observable<any>;
  private statusMasterSubject: BehaviorSubject<boolean> = new BehaviorSubject<any>({});
  statusMasterSubject$!: Observable<any>;
  private willCallSubject: BehaviorSubject<boolean> = new BehaviorSubject<any>({});
  willCallSubject$!: Observable<any>;


  constructor() {
    this.userDetailsSubject$ = this.userDetailsSubject.asObservable();
    this.encClaimIdSubject$ = this.encClaimIdSubject.asObservable();
    this.estimateDetailsSubject$ = this.estimateDetailsSubject.asObservable();
    this.paymentDetailSubject$ = this.paymentDetailSubject.asObservable();
    this.garageDetailSubject$ = this.garageDetailSubject.asObservable();
    this.statusMasterSubject$ = this.statusMasterSubject.asObservable();
    this.willCallSubject$ = this.willCallSubject.asObservable();
  }

  setUserDetails(value: any) {
    this.userDetailsSubject.next(value && typeof value === 'object' ? value : {});
  }

  /** Latest user object without subscribing (e.g. HTTP interceptors). */
  getUserDetailsSnapshot(): any {
    return this.userDetailsSubject.getValue();
  }

  getEncClaimIdSnapshot(): string {
    const v = this.encClaimIdSubject.getValue();
    return v != null && v !== '' ? String(v) : '';
  }

  /** Remove all persisted local/session data plus reset subjects — call on logout (success or failure). */
  clearUserSession(): void {
    this.userDetailsSubject.next({});
    this.encClaimIdSubject.next('');
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
      /* ignore */
    }
  }

  setEncClaimId(value: any){
    this.encClaimIdSubject.next(value);
  }

  setEstimateDetails(value: any){
    this.estimateDetailsSubject.next(value)
  }

  setPaymentDetails(value: any){
    this.paymentDetailSubject.next(value)
  }
  setGarageDetails(value: any){
    this.garageDetailSubject.next(value)
  }

  setStatusMaster(value: any){
    this.statusMasterSubject.next(value)
  }

  setWillCall(value: any) {
    this.willCallSubject.next(value)
  }
}
